import { render, staticRenderFns } from "./AddPosition.vue?vue&type=template&id=418c90a6&scoped=true"
import script from "./AddPosition.vue?vue&type=script&lang=js"
export * from "./AddPosition.vue?vue&type=script&lang=js"
import style0 from "./AddPosition.vue?vue&type=style&index=0&id=418c90a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "418c90a6",
  null
  
)

export default component.exports